import React 							from 'react';
import ReactDOM 						from 'react-dom';

import BLComponent						from '../core/_BLComponent.jsx';
import {CustomAlert,NotificationBar} 			
										from '../common/_Utilities.jsx';
import ModalFrame 						from '../common/_ModalFrame.jsx';
import {ClickShowTooltip}				from '../common/_Utilities.jsx';
import InventoryLoadingState			from './inventoryLoadingState.jsx';
import InventoryComparisonLanding		from './inventoryComparisonLanding.jsx';
import InventoryComparisonDetail		from './inventoryComparisonDetail.jsx';
import blAjax							from '../utils/_ajax.jsx';

export default class InventoryComparison extends BLComponent
{
	constructor (props) 
	{
		super(props);

		
		this.state = {
			pageShowing					: 0 	/* 0: Landing , 1: Loading , 2: Inventory Page */
		,	invASourceFrom				: 0 	/* 0: BrickLink, 1: Lego */
		,	invBSourceFrom				: 0		/* 0: BrickLink, 1: Lego */
		,   invAItemNo				  : ""
		,   invBItemNo				  : ""
		,   loadUserSetting			 : true
		,	landingPageData				: {
													show:false
												,	nothingToShow: true  }
		,	loadingStateData 			: {
													isLoadingDataError: false
										  }
		,	invDetailData				: {
													isEdit: 		false
												
												,	collapseRegular: true
												,	collapseExtra: true
												,	collapseCounter: true
												,	collapseAlternate: true

												,	inventoryRegularItems: []
												,	inventoryExtraItems: []
												,	inventoryCounterParts: []
												,	inventoryAlternateItems: []
										  }
		,	invA 						: {			setId: 			""
												,	setSeq: 		""
												,	source: 		""
												,	isPending: 		false
												,	isError: 		false
												,	title: 			""
												,	setImg: 		""
										}
		, 	invB 						: {			setId: 			""
												,	setSeq: 		""
												,	source: 		""
												,	isPending: 		false
												,	isError: 		false
												,	title: 			""
												,	setImg: 		""
										}
		,	inventoryComparisonSetting	: {
													enableWideScreen: 		true
												,	showLegoData: 			true
												,	hideExtraCounterAlter: 	false
												,	alwaysBreakMinifigures: true

										}
		,	inventoryComparisonTmpSet 	: {
													enableWideScreen: 		true
												,	showLegoData: 			true
												,	hideExtraCounterAlter: 	false
												,	alwaysBreakMinifigures: true

										}
		};
	}

	onPopState(e) {
		this.initSetLoading();
	}

	componentDidMount() 
	{
		const isLoggedIn = blapp.session.isLoggedIn();
		this.registerPopStateCallback((e) => this.onPopState(e));
/*
		window.addEventListener('popstate', (event) => {
			if ( (Object.keys(blapp.util.getUrlVars()).length) > 0 ) location.reload(true);
  		});
*/
		if (isLoggedIn)
		{
			blapp.models.fetch(
				"_ic"
				, {
						controller: "catalog.BLCInventoryComparison"
					, 	method: "getInventoryComparisonSettings"
					, 	params: []
					, 	refresh: true
				}
			).then(
				(data) => {
					const bLegoData =  (!$("#v3-checker").is(":visible"))?true:data.bLEGOData;
						
					var tmpData = this.state.inventoryComparisonSetting;
					tmpData.enableWideScreen		= data.bWideScreen;
					tmpData.showLegoData			= bLegoData;
					tmpData.hideExtraCounterAlter   = data.bHideExtra;
					tmpData.alwaysBreakMinifigures  = data.bBreakMinifig;

					var tmpSet = this.state.inventoryComparisonTmpSet;
					tmpSet.enableWideScreen		= data.bWideScreen;
					tmpSet.showLegoData			= bLegoData;
					tmpSet.hideExtraCounterAlter   = data.bHideExtra;
					tmpSet.alwaysBreakMinifigures  = data.bBreakMinifig;

					this.setState( {inventoryComparisonSetting: tmpData, inventoryComparisonTmpSet: tmpSet}, ()=>this.initSetLoading() );

				}
			).catch(
				(err) => {
					switch ( err )
					{
					case "EC_LOGIN_REQUIRED":
						break;
					default:
						console.log( err );
						break;
					}

					this.setState( { pageShowing: 0 } );
				}
			);
		}
		else
		{
			
			this.initSetLoading();
			blapp.refs.get("header").toggleMenu("login");
		}
		
	}

	initSetLoading() 
	{
		const that = this;
		$(window).on('popstate', function() {
			that.showLanding();
		});
		
		const itemNoA = blapp.util.getUrlVar("invA");
		const itemNoB = blapp.util.getUrlVar("invB");
		const sourceFromA = blapp.util.getUrlVar("sourceA");
		const sourceFromB = blapp.util.getUrlVar("sourceB");

		if ( (typeof itemNoA != "undefined") || (typeof itemNoB != "undefined" ) || (typeof sourceFromA != "undefined") || (typeof sourceFromB != "undefined") ) 
		{
			this.setState({invAItemNo: itemNoA, invASourceFrom: sourceFromA, invBItemNo: itemNoB, invBSourceFrom: sourceFromB, pageShowing:1}, ()=>this.loadingSetData());
		}
	}

	componentDidUpdate()
	{
		if (!this.state.inventoryComparisonSetting.enableWideScreen) {
			$(".inventory-comparison__show-sitewidthxl").addClass("inventory-comparison__hide-not-fixed");
			$(".inventory-comparison__item-list").addClass("inventory-comparison__grid-column--12");
			$(".inventory-comparison__grid-xl-cell--item-name").addClass("inventory-comparison__grid-column-span--6");


			$(".ic-row").removeClass("inventory-comparison__grid-split-y");
		}
		else
		{
			$(".inventory-comparison__show-sitewidthxl").removeClass("inventory-comparison__hide-not-fixed");
			$(".inventory-comparison__item-list").removeClass("inventory-comparison__grid-column--12");
			$(".inventory-comparison__grid-xl-cell--item-name").removeClass("inventory-comparison__grid-column-span--6");
			$(".ic-row").addClass("inventory-comparison__grid-split-y");
		}
	}

	render() 
	{
		var invDetailData = this.state.invDetailData;
		const reload = (Object.keys(blapp.util.getUrlVars()).length > 1 )?true:false;
		const isLoggedIn = blapp.session.isLoggedIn();
		const pageShowing = (reload && pageShowing == 0)?1:this.state.pageShowing;
		return (
			<div className=" main--white">
				<div id="v3-checker" className="inventory-comparison__dummy-0x0 inventory-comparison__show-r3-only">
				</div>
				{( ( (pageShowing == 0) && !reload) || !isLoggedIn )&&
					<InventoryComparisonLanding 
						data={{ landingPageData:this.state.landingPageData, invA:this.state.invA, invB:this.state.invB, invAItemNo: this.state.invAItemNo, invBItemNo: this.state.invBItemNo, invASourceFrom:this.state.invASourceFrom, invBSourceFrom:this.state.invBSourceFrom }}
						func={{
								submitForm: ()=>this.submitForm()
							,   changeInvA: (itemNo) => this.changeInvA(itemNo)
							,   changeInvB: (itemNo) => this.changeInvB(itemNo)
							,   changeInvASourceFrom: (source) => this.changeInvASourceFrom(source)
							,   changeInvBSourceFrom: (source) => this.changeInvBSourceFrom(source)
						}}
					/>
				}
				{((pageShowing == 1) && reload && isLoggedIn)&&
					<InventoryLoadingState 
						data={{ 
								isLoadingDataError: this.state.loadingStateData.isLoadingDataError
							,	invA:this.state.invA
							,	invB:this.state.invB 
						}}
						func={{
								backToLanding: () => this.backToLanding()
						}}
					/>
				}
				{(pageShowing == 2)&&
					<InventoryComparisonDetail 
						data={{ 
								inventoryComparisonSetting: this.state.inventoryComparisonSetting
							,	invA:this.state.invA
							,	invB:this.state.invB
							,	invDetailData: invDetailData
							,	invASourceFrom:this.state.invASourceFrom
							,	invBSourceFrom:this.state.invBSourceFrom
							,   invAItemNo: this.state.invAItemNo
							,   invBItemNo: this.state.invBItemNo
						}}
						func={{ 
								toggleInvSetEditMode: () => this.toggleInvSetEditMode()
							,	toggleCollapse: (listType) => this.toggleCollapse(listType)
							,	updateSetData: () => this.updateSetData()
							,	updateInventoryComparisonSettings: (updateField) => this.updateInventoryComparisonSettings(updateField)
							,	reverseInventoryComparisonSettings: () => this.reverseInventoryComparisonSettings()
							,	saveInventoryComparisonSettings: () => this.saveInventoryComparisonSettings()
							,   changeInv: (itemNo, target) => this.changeInv(itemNo, target)
							,   changeInvSourceFrom: (source, target) => this.changeInvSourceFrom(source, target)
						}}
					/>
				}
			</div>
		)
		
	}
	showLanding() {
		this.setState({pageShowing: 0} );
	}
	backToLanding() {
		this.showLanding();
		history.back();
	}

	toggleInvSetEditMode() {
		var invDetailData = this.state.invDetailData;
		invDetailData.isEdit = invDetailData.isEdit?false:true;
		this.setState( {invDetailData: invDetailData} );
	}

	submitForm() {
		this.pushHistory();
		this.loadingSetData();
	}

	pushHistory() {
		const url = blapp.util.addParamToUrl("invA", this.state.invAItemNo, blapp.util.addParamToUrl( "sourceA" , this.state.invASourceFrom , blapp.util.addParamToUrl( "invB" , this.state.invBItemNo ,  blapp.util.addParamToUrl( "sourceB", this.state.invBSourceFrom,  blapp.url2.getInvComparisonUrl() ) ) ) );
		history.pushState('', '', url.href );
	}

	loadingSetData()
	{
		var loadingStateData = this.state.loadingStateData;
		loadingStateData.isLoadingDataError = false;
		
		/* Call loadingDataError() when there's an error while loading set data */
		const invAItemNo = ( this.state.invASourceFrom == 1 && this.state.invAItemNo.match(/-\d$/) )? this.state.invAItemNo.substring(0, this.state.invAItemNo.indexOf("-")) :this.state.invAItemNo
		const invBItemNo = ( this.state.invBSourceFrom == 1 && this.state.invBItemNo.match(/-\d$/) )? this.state.invBItemNo.substring(0, this.state.invBItemNo.indexOf("-")) :this.state.invBItemNo
		

		if( !blapp.session.isLoggedIn() )
		{
			blapp.refs.get( "header" ).showLogin( );
		}
		else 
		{
			this.setState({pageShowing: 1, loadingStateData: loadingStateData } );

			blapp.models.fetch(
				"_ic"
				, {
						controller: "catalog.BLCInventoryComparison"
					, 	method: "getInventoryComparisonData"
					, 	params: [invAItemNo.trim(), invBItemNo.trim(), this.state.invASourceFrom.toString(), this.state.invBSourceFrom.toString(), this.state.inventoryComparisonSetting.alwaysBreakMinifigures]
					, 	refresh: true
				}
			).then(
				(data) => {
					var tmpData = this.state.invDetailData;
					tmpData.inventoryRegularItems   = data.regularItems;
					tmpData.inventoryExtraItems	 = data.extraItems;
					tmpData.inventoryCounterParts   = data.counterParts;
					tmpData.inventoryAlternateItems   = data.alternateItems;

					let arrInvA	 = data.itemNoA.split("-");
					var tmpInvA	 = this.state.invA;
					tmpInvA.setId   = arrInvA[0];
					tmpInvA.setSeq  = arrInvA[1]?arrInvA[1]:"";

					tmpInvA.setImg	  = data.invAImageUrl;
					tmpInvA.title	   = data.invATitle;
					tmpInvA.isPending   = data.invAPending;
					tmpInvA.isError	 = data.invAError;


					if ( data.invASource == 0 )
						tmpInvA.source = "BrickLink";
					else
						tmpInvA.source = "LEGO";

					let arrInvB	 = data.itemNoB.split("-");
					var tmpInvB	 = this.state.invB;
					tmpInvB.setId   = arrInvB[0];
					tmpInvB.setSeq  = arrInvB[1]?arrInvB[1]:"";

					tmpInvB.setImg	  = data.invBImageUrl;
					tmpInvB.title	   = data.invBTitle;
					tmpInvB.isPending   = data.invBPending;
					tmpInvB.isError	 = data.invBError;

					if ( data.invBSource == 0 )
						tmpInvB.source = "BrickLink";
					else
						tmpInvB.source = "LEGO";

					if ( data.invAError || data.invBError )
					{
						this.setState( {invAItemNo: data.itemNoA, invBItemNo: data.itemNoB, invASourceFrom: data.invASource, invBSourceFrom: data.invBSource/*, pageShowing: 0*/});
						this.loadingDataError();
					}
					else
						this.setState( { invDetailData: tmpData, pageShowing: 2, invAItemNo: data.itemNoA, invBItemNo: data.itemNoB, invASourceFrom: data.invASource, invBSourceFrom: data.invBSource, invA: tmpInvA, invB:tmpInvB } );

				}
			).catch(
				(err) => {
					switch ( err )
					{
					case "EC_INVENTORY_COMPARISON_INVALID_SET_A":
						break;
					case "EC_INVENTORY_COMPARISON_INVALID_SET_B":
						break;
					case "EC_LOGIN_REQUIRED":
						location.reload();
						break;
					default:
						console.log( err );
						break;
					}

					this.setState( { pageShowing: 0 } );
				}
			);
		}
	}

	loadingDataError() {
		var loadingStateData = this.state.loadingStateData;
		loadingStateData.isLoadingDataError = true;
		this.setState({pageShowing: 1, loadingStateData: loadingStateData } );
	}

	showSetDetail() {
		this.setState({pageShowing: 2});
	}

	updateSetData() {

		let tmpInvDetail = this.state.invDetailData;
		tmpInvDetail.isEdit = false;

		this.setState({ invDetailData: tmpInvDetail });
		this.pushHistory();
		this.loadingSetData();

	}

	toggleCollapse(listType) {
		var invDetailData = this.state.invDetailData;
		if (listType == 0) invDetailData.collapseRegular = !invDetailData.collapseRegular;
		if (listType == 1) invDetailData.collapseExtra = !invDetailData.collapseExtra;
		if (listType == 2) invDetailData.collapseCounter = !invDetailData.collapseCounter;
		if (listType == 3) invDetailData.collapseAlternate = !invDetailData.collapseAlternate;

		this.setState({ invDetailData:invDetailData });
	}

	reverseInventoryComparisonSettings() {
		var tmpSet = this.state.inventoryComparisonTmpSet;
		var inventoryComparisonSetting = this.state.inventoryComparisonSetting;
		
		inventoryComparisonSetting.enableWideScreen = tmpSet.enableWideScreen;
		inventoryComparisonSetting.showLegoData = tmpSet.showLegoData;
		inventoryComparisonSetting.hideExtraCounterAlter = tmpSet.hideExtraCounterAlter;
		inventoryComparisonSetting.alwaysBreakMinifigures = tmpSet.alwaysBreakMinifigures;

		this.setState({inventoryComparisonSetting:inventoryComparisonSetting});
	}


	updateInventoryComparisonSettings( updateField ) {
		var inventoryComparisonSetting = this.state.inventoryComparisonSetting;
		switch(updateField) 
		{
			case 0: inventoryComparisonSetting.enableWideScreen = !inventoryComparisonSetting.enableWideScreen;
					if (inventoryComparisonSetting.enableWideScreen) inventoryComparisonSetting.showLegoData = true;
					break;
			case 1: inventoryComparisonSetting.showLegoData = !inventoryComparisonSetting.showLegoData;
					break;
			case 2: inventoryComparisonSetting.hideExtraCounterAlter = !inventoryComparisonSetting.hideExtraCounterAlter;
					break;
			case 3: inventoryComparisonSetting.alwaysBreakMinifigures = !inventoryComparisonSetting.alwaysBreakMinifigures;
					break;
		}
		this.setState({inventoryComparisonSetting:inventoryComparisonSetting});
	}

	saveInventoryComparisonSettings() {
		/* SAVVE */
		var inventoryComparisonSetting = this.state.inventoryComparisonSetting;
		var inventoryComparisonTmpSet = this.state.inventoryComparisonTmpSet;
		const isLoggedIn = blapp.session.isLoggedIn();

		const reloadData = ( inventoryComparisonTmpSet.alwaysBreakMinifigures != inventoryComparisonSetting.alwaysBreakMinifigures )?true:false;

		inventoryComparisonTmpSet.enableWideScreen = inventoryComparisonSetting.enableWideScreen;
		inventoryComparisonTmpSet.showLegoData = inventoryComparisonSetting.showLegoData;
		inventoryComparisonTmpSet.hideExtraCounterAlter = inventoryComparisonSetting.hideExtraCounterAlter;
		inventoryComparisonTmpSet.alwaysBreakMinifigures = inventoryComparisonSetting.alwaysBreakMinifigures;

		this.setState({inventoryComparisonTmpSet:inventoryComparisonTmpSet});

		if (isLoggedIn)		
		{
			blapp.models.fetch(
				"_ic"
				, {
						controller: "catalog.BLCInventoryComparison"
					, 	method: "setInventoryComparisonSettings"
					, 	params: [this.state.inventoryComparisonSetting.enableWideScreen, this.state.inventoryComparisonSetting.showLegoData, this.state.inventoryComparisonSetting.hideExtraCounterAlter, this.state.inventoryComparisonSetting.alwaysBreakMinifigures]
					, 	refresh: true
				}
			).then(
				(data) => {
					blapp.track.trackGeneral( 10110, this.state.inventoryComparisonSetting.enableWideScreen?1:0, this.state.inventoryComparisonSetting.showLegoData?1:0, this.state.inventoryComparisonSetting.hideExtraCounterAlter?1:0, this.state.inventoryComparisonSetting.alwaysBreakMinifigures?1:0 );
				}
			).catch(
				(err) => {
					switch ( err )
					{
					case "EC_LOGIN_REQUIRED":
						break;
					default:
						console.log( err );
						break;
					}

					this.setState( { pageShowing: 0 } );
				}
			);
		}

		if (reloadData) {
			this.loadingSetData();
		}
	}

	changeInvA( itemNo ) {
		let tmpInvA	 = this.state.invA;
		tmpInvA.setId   = itemNo.split("-")[0];
		tmpInvA.setSeq  = itemNo.split("-")[1]?itemNo.split("-")[1]:"";

		this.setState({ invAItemNo : itemNo, invA: tmpInvA });

	}

	changeInvB( itemNo ) {
		let tmpInvB	 = this.state.invB;
		tmpInvB.setId   = itemNo.split("-")[0];
		tmpInvB.setSeq  = itemNo.split("-")[1]?itemNo.split("-")[1]:"";

		this.setState({ invBItemNo : itemNo, invB: tmpInvB });
	}

	changeInv( itemNo, target ) {
		if ( target == 0 )
			this.changeInvA( itemNo );
		else if ( target == 1 )
			this.changeInvB( itemNo );
	}

	changeInvASourceFrom( source ) {
		let tmpInvA	 = this.state.invA;
		tmpInvA.source   = (source==0)?"BrickLink":"LEGO";
		this.setState({ invASourceFrom : source, invA: tmpInvA });
	}

	changeInvBSourceFrom( source ) {
		let tmpInvB	 = this.state.invB;
		tmpInvB.source   = (source==0)?"BrickLink":"LEGO";

		this.setState({ invBSourceFrom : source, invB:tmpInvB });
	}

	changeInvSourceFrom( source, target ) {
		if ( target == 0 )
			this.changeInvASourceFrom( source );
		else if ( target == 1 )
			this.changeInvBSourceFrom( source );
	}

}
 

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<InventoryComparison blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-inventory-comparison' )
						);
		blapp.refs.register( "main", elem );
	}
);


